import { WithUserNamespace } from '../../state/user';

export const getEnrolledUser = (state: WithUserNamespace) =>
    state?.user?.isUserEnrolledInReferral || false;
